import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAnalytics from "@faire/web-api--source/routes/www/brand-portal/analytics";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const AboutAnalyticsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Track your shop's performance on the <LinkFormatting>Analytics</LinkFormatting> page in your portal. Here you may review your sales, traffic, and customer review data. Your analytics summary includes your order volume, conversion rate, and average rating. To see performance for different time periods, adjust the date range using the dropdown."
          values={{
            LinkFormatting: AnalyticsLinkFormatting,
          }}
          description={{
            text: "Header of the list in how to receive payments",
          }}
        />
      </Typography>
    </Column>
  );
};

const AnalyticsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalAnalytics()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);
